import { FormArray } from '@angular/forms';
import { Component, Input, OnInit, Inject, LOCALE_ID } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { AppSettings } from 'app/shared/app-settings';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { MenuHandler } from 'app/shared/menu-handler';
import { NofshonimService } from 'app/nofshonim-chul/nofshonim.service';
import { INirsham } from './../../nofesh/model/nirsham';
import { IAgeRanges } from './../model/age-ranges';
import { count } from '../../../../node_modules/rxjs/operator/count';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';
import { DateService } from 'app/shared/date.service';
import { ENofeshType } from 'app/shared/enums/enofesh-type.enum';
declare var $: any;


@Component({
    moduleId: module.id,
    templateUrl: './nirshamim.component.html',
    selector: 'nirshamimChul'
})

export class NirshamimChulComponent implements OnInit {

    @Input('group') public nirshamGroup: FormGroup;
    @Input() index;
    @Input() ageRanges: IAgeRanges;
    @Input() form: FormGroup;
    @Input() nofeshType: number;
    @Input() fromTkufatNofesh: Date;

    minYear: Date = new Date();
    maxYear: Date = new Date();
    darkonMaxYear: Date = new Date();
    darkonMinYear: Date = new Date();

    nirshamDetails: INirsham

    get isAmit() { return this.nirshamGroup.get('is_amit').value > 0 ? true : false };
    get isNilve() { return this.nirshamGroup.get("is_nilve").value > 0 ? true : false };
    get isYeled() { return this.nirshamGroup.get("is_yeled").value > 0 ? true : false };
    get isTinok() { return this.nirshamGroup.get("is_tinok").value > 0 ? true : false };

    is_rashum_to_other_nofesh: boolean;
    tr_leida_minYear: number = new Date().getFullYear() - 80;
    tr_leida_maxYear: number = new Date().getFullYear() + 1;

    tokef_darkon_minYear: number = new Date().getFullYear();
    tokef_darkon_maxYear: number = new Date().getFullYear() + 20;
    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        dayLabels: AppSettings.dayLabels,
        monthLabels: AppSettings.monthLabels,
        showTodayBtn: false,
        minYear: this.tr_leida_minYear,
        maxYear: this.tr_leida_maxYear,
        firstDayOfWeek: 'su',
        alignSelectorRight: true,
        disableSince: { year: this.tr_leida_maxYear, month: 1, day: 1 },
        disableUntil: { year: this.tr_leida_minYear, month: 1, day: 1 }


    };

    now: Date = new Date();
    disabled: boolean = false;
    is_charigat_gil: boolean = false;
    charigat_gil_message: string;
    double_ms_zehut: boolean = false;
    set_read_only: boolean = false;
    ms_zehut_valid: boolean = true;
    amit_only_message: boolean = false;
    no_zakaut_message: boolean = false;

    tokefDarkonDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        dayLabels: AppSettings.dayLabels,
        monthLabels: AppSettings.monthLabels,
        showTodayBtn: false,
        minYear: this.tokef_darkon_minYear,
        maxYear: this.tokef_darkon_maxYear,
        firstDayOfWeek: 'su',
        alignSelectorRight: true,
        disableSince: { year: this.tokef_darkon_maxYear, month: 1, day: 1 },
        disableUntil: { year: this.tokef_darkon_minYear, month: this.now.getMonth() + 1, day: this.now.getDate() }
    };

    isReadonly: boolean = false;

    constructor(private _nofshonimService: NofshonimService,
        private ds: DateService,
        @Inject(LOCALE_ID) public localeId: string,
        public intlService: IntlService
    ) { }

    ngOnInit() {
        this.localeId = "he-IL";
        (<CldrIntlService>this.intlService).localeId = "he-IL";
        let d = new Date();
        this.minYear.setFullYear(d.getFullYear() - 75);
        this.darkonMinYear.setFullYear(d.getFullYear());
        this.darkonMaxYear.setFullYear(d.getFullYear() + 20);

        // Amit mazmin details are not entered yet
        if (this.index === 0 && !this.nirshamGroup.controls["shem_prati"].value && !this.nirshamGroup.controls["tr_leida"].value) {
            // Get amit details when details are not available in the form.
            let ms_zehut: string = JSON.parse(localStorage.getItem('ms_zehut_mazmin'));
            this.getNirshamDetails(ms_zehut);
        }

        if (this.index > 0 && Number(this.nirshamGroup.controls["ms_zehut"].value) > 0) {
            // If nirsham is not amit mazmin and details saved before
            this.isReadonly = true;
        }
    }



    getNirshamDetails(msZehut: string) {
        this.amit_only_message = false;
        this.no_zakaut_message = false;

        if (!msZehut || msZehut.includes(" ")) {
            this.resetDetailsFields();
            return;
        }

        this.ms_zehut_valid = this.validateMsZehut(msZehut);
        if (!this.ms_zehut_valid) {
            return;
        }

        this.resetDetailsFields();
        this.set_read_only = false;
        this.disabled = false;



        this.double_ms_zehut = false;
        this.is_charigat_gil = false;
        let nirshamimArray = this.form.get('nirshamim') as FormArray;
        let identity_list = nirshamimArray.getRawValue().map(t => Number(t.ms_zehut));
        let doubleMsZehut = identity_list.filter(t => t == Number(msZehut));
        if (identity_list.filter(t => t == Number(msZehut)).length > 1) {
            this.double_ms_zehut = true;
            this.resetDetailsFields();
            return;
        }

        this._nofshonimService.getNirshamDetails(msZehut).subscribe(
            (res: INirsham) => {
                if (res) {
                    let tr_leida;
                    this.is_rashum_to_other_nofesh = false;
                    this.nirshamDetails = res;


                    //
                    // Checks amitim besides the amit that registered the room
                    if (this.isAmit && this.index > 0) {
                        if (this.nirshamDetails.ms_zehut === 0) {
                            this.amit_only_message = true;
                            this.resetDetailsFields();
                            return;
                        }

                        if (this.nirshamDetails.ms_zehut > 0 && this.nirshamDetails.zakaut == 0) {
                            this.no_zakaut_message = true;
                            this.resetDetailsFields();
                            return;
                        }

                        if (this.nirshamDetails.ms_zehut > 0 && this.nirshamDetails.id_nofesh > 0) {
                            if (this.nirshamDetails.amuta_kidum != 1 && this.nirshamDetails.mimush != 0 && this.nirshamDetails.mimush != 1) {
                                this.no_zakaut_message = true;
                                this.resetDetailsFields();
                            }
                            if (this.nirshamDetails.amuta_kidum == 1 && this.nirshamDetails.mimush > 0) {
                                this.no_zakaut_message = true;
                                this.resetDetailsFields();
                            }
                            return;
                        }
                    }

                    if (this.nirshamDetails.ms_zehut > 0) {
                        this.nirshamGroup.patchValue({ ms_zehut: this.nirshamDetails.ms_zehut });
                        this.nirshamGroup.patchValue({ tr_leida: (this.nirshamDetails.tr_leida) ? new Date(this.nirshamDetails.tr_leida) : "" });
                        this.nirshamGroup.patchValue({ shem_prati: this.nirshamDetails.shem_prati });
                        this.nirshamGroup.patchValue({ shem_mishpacha: this.nirshamDetails.shem_mishpacha });
                        this.nirshamGroup.patchValue({ shem_prati_loazi: this.nirshamDetails.shem_prati_loazi });
                        this.nirshamGroup.patchValue({ shem_mishpacha_loazi: this.nirshamDetails.shem_mishpacha_loazi });
                        this.nirshamGroup.patchValue({ ms_darkon: this.nirshamDetails.ms_darkon });
                        this.nirshamGroup.patchValue({ tr_tokef_darkon: (this.nirshamDetails.tr_tokef_darkon) ? new Date(this.nirshamDetails.tr_tokef_darkon) : "" });
                        if (this.isAmit || this.isNilve) {
                            this.nirshamGroup.patchValue({ phone: this.nirshamDetails.phone });
                        }
                        this.nirshamGroup.patchValue({ gender: this.nirshamDetails.gender });
                    }
                    else if (this.nirshamDetails.shem_prati && this.nirshamDetails.tr_leida) {
                        this.nirshamGroup.patchValue({ tr_leida: (this.nirshamDetails.tr_leida) ? new Date(this.nirshamDetails.tr_leida) : "" });
                        this.nirshamGroup.patchValue({ shem_prati: this.nirshamDetails.shem_prati });
                    }
                }
                else {
                    this.disabled = false;
                    this.set_read_only = false;
                }
            }
        )
    }

    resetDetailsFields(): void {
        this.nirshamGroup.patchValue({ tr_leida: null });
        this.nirshamGroup.patchValue({ shem_prati: "" });
        this.nirshamGroup.patchValue({ gender: "" });

        this.nirshamGroup.patchValue({ shem_mishpacha: "" });
        this.nirshamGroup.patchValue({ shem_prati_loazi: "" });
        this.nirshamGroup.patchValue({ shem_mishpacha_loazi: "" });
        this.nirshamGroup.patchValue({ ms_darkon: "" });
        this.nirshamGroup.patchValue({ tr_tokef_darkon: "" });


        if (this.isAmit || this.isNilve) {
            this.nirshamGroup.patchValue({ phone: "" });
        }
    }

    onDateChanged(value: Date): void {
        if (!value || value.getFullYear() < 1950) return;

        this._validateAge(value);
    }

    private _validateAge(tr_leida: Date) {
        if (!tr_leida) return;


        if (this.isYeled || this.isTinok || this.isNilve) {
            const age: number = this._calculateAge(tr_leida, this.fromTkufatNofesh);
            //this check is for the initialization of the page, it is loaded with a big date.
            if (age > 100) return;


            this.is_charigat_gil = false;
            this.charigat_gil_message = '';

            if (this.isYeled && (age < this.ageRanges.child_min_age || age > this.ageRanges.child_max_age)) {
                this.is_charigat_gil = true;
                this.charigat_gil_message = `קיימת חריגת גיל. ניתן לרשום ילדים בגילים ${this.ageRanges.child_min_age} - ${this.ageRanges.child_max_age} (כולל)`;
            }
            else if (this.isTinok) {
                const tinokMaxAge = 2;
                if ((this.nofeshType === ENofeshType.NofeshPnim || this.nofeshType === ENofeshType.MeurganimPnim) && age > tinokMaxAge) {
                    this.is_charigat_gil = true;
                    this.charigat_gil_message = `קיימת חריגת גיל. התינוק חייב להיות עד גיל שנתיים (כולל)`;
                }
                else if ((this.nofeshType === ENofeshType.NofeshChul || this.nofeshType === ENofeshType.MeurganimChul || this.nofeshType === ENofeshType.MishpachotChul) && age >= tinokMaxAge) {
                    this.is_charigat_gil = true;
                    this.charigat_gil_message = `קיימת חריגת גיל. התינוק חייב להיות עד גיל שנתיים (לא כולל)`;
                }
            }
            else if (this.isNilve && (age < this.ageRanges.child_max_age)) {
                this.is_charigat_gil = true;
                this.charigat_gil_message = `קיימת חריגת גיל. הנלווה חייב להיות מעל גיל ${this.ageRanges.child_max_age} (כולל)`;
            }
        }
    }


    private _calculateAge(trLeida: Date, nofeshDate: Date) {
        if (typeof nofeshDate === "string") {
            nofeshDate = new Date(nofeshDate);
        }

        const birth = {
            day: trLeida.getDate(),
            month: trLeida.getMonth() + 1,
            year: trLeida.getFullYear()
        };

        const nofesh = {
            day: nofeshDate.getDate(),
            month: nofeshDate.getMonth() + 1,
            year: nofeshDate.getFullYear()
        };

        let age = nofesh.year - birth.year;
        if (nofesh.month < birth.month) // Nofesh month is bofore birthday month
        {
            age--;
        }
        else if ((birth.month === nofesh.month) && (nofesh.day < birth.day)) // Nofesh and birthday at the same month, but nofesh is before birthday
        {
            age--;
        }

        return age;
    }

    validateMsZehut(value: string): boolean {
        if (value.length == 0)
            return false;

        var result = true;
        var first8 = null;
        var cifratBikoret = null;
        try {
            if (value.length == 10)
                first8 = value.substring(0, 9);
            else {
                if (value.length == 9)
                    first8 = "0" + value.substring(0, 8);
                else
                    first8 = "00" + value.substring(0, 8);
            }
            cifratBikoret = value.substring(value.length - 1);
            var checkDigits = 0 * 1;
            var temp = 0;
            var i = 0;

            for (i = 1; i <= 9; i++) {
                temp = first8.charAt(i - 1);
                checkDigits = temp * 1 + checkDigits * 1;
                if ((i % 2) == 1) {
                    checkDigits = temp * 1 + checkDigits * 1;
                    if (temp > 4)
                        checkDigits = checkDigits * 1 - 9;
                }
            }
            checkDigits = (10 - checkDigits % 10) % 10;
            result = (checkDigits * 1 == cifratBikoret * 1);
        }
        catch (e) { result = false; }
        if (value == "0")
            result = false;
        return result;
    }
}